import React, { useState } from 'react';
import { Typography } from '@material-ui/core';

interface PostInfoProps {
  title: string;
  description: string;
  firstName: string;
  lastName: string;
}

const PostInfo: React.FC<PostInfoProps> = ({ title, description, firstName, lastName }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div style={styles.infoContainer}>
      <Typography variant="body2" style={styles.username}>{firstName}</Typography>
      <Typography
        variant="body2"
        style={expanded ? styles.titleExpanded : styles.title}
        onClick={() => setExpanded(!expanded)}
      >{title}</Typography>
      <Typography variant="body2" style={styles.description}>{description}</Typography>
    </div>
  );
};

const styles = {
  infoContainer: {
    // display: 'flex',
    // flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'flex-start',
    // width: 350,
    // height: "60px",
    // position: 'absolute',
    // bottom: 60,
    color: 'white',
    width: "80%",

    // left: 25
  } as React.CSSProperties,
  title: {
    fontWeight: 700,
    fontSize: '12px',
    fontFamily: 'Inter',
    lineHeight: '20px',
    cursor: "pointer",

    display: "-webkit-box",
    WebkitLineClamp: 1, // 👈 1 line like Instagram
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },

  titleExpanded: {
    fontWeight: 700,
    fontSize: '12px',
    fontFamily: 'Inter',
    lineHeight: '20px',
    cursor: "pointer",
    display: "block",
  },
  description: {
    marginTop: "8px",
    display: "-webkit-box",
    WebkitLineClamp: 2, // number of lines
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  } as React.CSSProperties,
  username: {
    fontWeight: 700,
    fontSize: '16px',
    fontFamily: 'Inter',
    lineHeight: '24px',
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  } as React.CSSProperties,
};

export default PostInfo;
